// extracted by mini-css-extract-plugin
export default {"password-confirmation__input":"PasswordConfirmation_password-confirmation__input__CEKpC"};